import React from "react";
import { FaEye, FaLayerGroup, FaUsers } from "react-icons/fa";

import {
  getAllCoachNames,
  getGroupAdherents,
  getGroupAdherentsCount,
  getGroupColorClasses,
  getGroupName,
  getStatusLabel,
  getStatusStyle,
} from "../utils/adminGroupsUtils";

function GroupsTable({ groups = [], onOpen }) {
  return (
    <section className="hidden overflow-hidden rounded-[2rem] border border-slate-200 bg-white shadow-xl shadow-slate-200/60 dark:border-white/10 dark:bg-slate-900 dark:shadow-black/20 lg:block">
      <div className="overflow-x-auto">
        <table className="w-full min-w-[1180px] text-left">
          <thead>
            <tr className="border-b border-slate-200 bg-slate-50 text-[11px] font-bold uppercase tracking-[0.14em] text-slate-400 dark:border-white/10 dark:bg-white/[0.03]">
              <th className="px-4 py-3">Groupe</th>
              <th className="px-4 py-3">Utilisateur / coach</th>
              <th className="px-4 py-3">Statut</th>
              <th className="px-4 py-3">Adhérents</th>
              <th className="px-4 py-3">Aperçu liste</th>
              <th className="px-4 py-3 text-right">Action</th>
            </tr>
          </thead>

          <tbody className="divide-y divide-slate-100 dark:divide-white/10">
            {groups.map((group) => {
              const color = getGroupColorClasses(group);
              const adherents = getGroupAdherents(group);
              const count = getGroupAdherentsCount(group);

              return (
                <tr
                  key={group.id}
                  className="text-sm transition hover:bg-sky-50/60 dark:hover:bg-white/[0.03]"
                >
                  <td className="px-4 py-3">
                    <div className="flex min-w-[260px] items-center gap-3">
                      <div
                        className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-gradient-to-br ${color.gradient} text-white shadow-lg shadow-slate-200 dark:shadow-black/30`}
                      >
                        <FaLayerGroup />
                      </div>

                      <div className="min-w-0">
                        <p className="truncate font-bold text-slate-950 dark:text-white">
                          {getGroupName(group)}
                        </p>

                        <p className="mt-0.5 text-xs font-semibold text-slate-400">
                          ID #{group.id} · ordre {group.ordre_groupe || 0}
                        </p>
                      </div>
                    </div>
                  </td>

                  <td className="px-4 py-3">
                    <p className="max-w-[260px] truncate font-semibold text-slate-600 dark:text-white/60">
                      {getAllCoachNames(group)}
                    </p>
                  </td>

                  <td className="px-4 py-3">
                    <span
                      className={`inline-flex min-h-8 items-center rounded-2xl px-3 text-xs font-bold ${getStatusStyle(
                        group,
                      )}`}
                    >
                      {getStatusLabel(group)}
                    </span>
                  </td>

                  <td className="px-4 py-3">
                    <span className={`inline-flex min-h-9 items-center gap-2 rounded-2xl px-3 text-xs font-bold ${color.badge}`}>
                      <FaUsers />
                      {count} adhérent{count > 1 ? "s" : ""}
                    </span>
                  </td>

                  <td className="px-4 py-3">
                    <p className="line-clamp-2 max-w-xl text-xs font-semibold leading-5 text-slate-500 dark:text-white/50">
                      {adherents.length > 0
                        ? adherents
                            .slice(0, 5)
                            .map((adherent) =>
                              [adherent.prenom, adherent.nom]
                                .filter(Boolean)
                                .join(" "),
                            )
                            .join(", ")
                        : "Aucun adhérent"}
                      {adherents.length > 5 ? ` +${adherents.length - 5}` : ""}
                    </p>
                  </td>

                  <td className="px-4 py-3 text-right">
                    <button
                      type="button"
                      onClick={() => onOpen(group)}
                      className="inline-flex min-h-10 items-center justify-center gap-2 rounded-2xl bg-blue-700 px-4 py-2 text-xs font-bold text-white transition hover:-translate-y-0.5 hover:bg-blue-800"
                    >
                      <FaEye />
                      Détails
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </section>
  );
}

export default GroupsTable;